import React, { useState, useEffect, useRef } from 'react'
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'
import search from '../../../Assets/home2/search.svg'
import icon18 from '../../../Assets/crane/icon18.svg'
import icon6 from '../../../Assets/crane/icon6.svg'
import icon7 from '../../../Assets/crane/icon7.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import mapimg from '../../../Assets/mapimg.png'

import img2 from '../../../Assets/add/img2.png'
import icon11 from '../../../Assets/crane/recoveryvan.avif'
import img3 from '../../../Assets/add/img3.png'
import MapForVendorDistance from '../Map/MapForVendorDistance.jsx'
import '../FirstPageDesigns/FirstPage.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import assignedTask from '../../../Assets/assignedTask.png'
import comingCrane from '../../../Assets/comingCrane.png'
import checksuccess from '../../../Assets/checksuccess.png'
import crossUser from '../../../Assets/crossUser.png'
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import filterUser from '../../../Assets/filterUser.png'
import telephonecall from '../../../Assets/telephonecall.png'
import mediumCrane from '../../../Assets/crane/mediumCrane.jpg'
import mediumRecoveryVan from '../../../Assets/crane/mediumRecoveryVan.jpg'
import frontLeft from '../../../Assets/crane/front-left.jpg'
import { ChevronDown, X } from "lucide-react";
import craneonmap from '../../../Assets/crane/craneonmap.png';

import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import { useWebSocket } from '../../../context/WebSocketContext.jsx' // i am edited websocket;
import { ClipLoader } from 'react-spinners';
import { Alert } from '@mui/material';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ModalButton from '../FirstPageDesigns/ModalButton.jsx';
import RatingModal from './RatingModal.jsx';
import CraneFirstPage from './CraneFirstPage.jsx'
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import { motion, AnimatePresence, useMotionValue, useTransform } from "framer-motion";
import SuccessMessage from './SuccessMessage.jsx'
import OLAMapsForDriverLocation from '../../../Component/Customers/OLAMapsForDriverLocation.jsx'
import { Phone, Info, MapPin, Edit3, Gift, PhoneCall, WifiHigh, ClipboardMinus, FastForward, MapPinHouse } from 'lucide-react';
import ShowVehicleInspectionFlow from '../FirstPageDesigns/VehicleInspectionFlow.jsx'
import OLAMapsForCustomerView from '../../../Component/Customers/OLAMapsForCustomerView.jsx'
import PaymentModalWorkDone from './PaymentModalWorkDone.jsx'

function VendorStatusTracking({ vehicleNumber }) {

    const navigate = useNavigate()
    const { messages, setMessages } = useWebSocket();
    const { state } = useLocation();

    const [currentStage, setCurrentStage] = useState([]); // Example stage
    //console.log("currentStage123", currentStage)
    const [isImageContainerVisible, setIsImageContainerVisible] = useState(false);
    const [data, setData] = useState([]);
    const [dummyData, setDummyData] = useState([]);
    const [workDone, setWorkDone] = useState(false);
    const [driverLocation, setDriverLocation] = useState(null);
    //console.log('driverLocation current 123', driverLocation)
    const [currentItems, setCurrentItems] = useState(data);
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [selectedAction, setSelectedAction] = useState(null)
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);
    const [distance, setDistances] = useState([])
    //console.log("distacneeerwerw", distance)
    const [avg, setAvg] = useState([])
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [filter, setFilter] = useState('')
    const [doneFetching, setDoneFetching] = useState(false)
    const [showPopup, setShowPopup] = useState(false);
    const callContainerRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleSheet = () => {
        setIsExpanded(prev => !prev);
    };
    const y = useMotionValue(0); // drag distance
    const sheetRef = useRef();

    const handleDragEnd = (_, info) => {
        const offset = info.offset.y;
        const velocity = info.velocity.y;

        // Decide based on drag distance or speed
        if (offset > 100 || velocity > 100) {
            setIsExpanded(false); // collapse
        } else {
            setIsExpanded(true); // expand
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (callContainerRef.current && !callContainerRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);




    //console.log("avg", avg)
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    // const currentService = localStorage.getItem("currentService")
    const [currentService, setCurrentService] = useState(null);

    const [currentAccidentCode, setCurrentAccidentCode] = useState("");
    const [vendorDriverCode, setVendorDriverCode] = useState(null);
    //console.log('vendorDriverCode', vendorDriverCode)
    //console.log('currentAccidentCode123456', currentAccidentCode)
    const [isModalOpenForReached, setIsModalOpenForReached] = useState(false);
    const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [openRatingModal, setOpenRatingModal] = useState(false);

    const [isModalOpenForOTP, setIsModalOpenForOTP] = useState(false);
    const [isModalOpenForConfirmDetails, setIsModalOpenForConfirmDetails] = useState(false);
    const [isModalOpenForJobDone, setIsModalOpenForJobDone] = useState(false);



    //console.log('currentSErivies', currentService)

    const stages = [
        { label: "Requested", icon: ClipboardMinus },
        { label: "In Transit", icon: FastForward },
        { label: "Reached", icon: MapPinHouse },
    ];

    //console.log('isImageContainer', isImageContainerVisible)

    useEffect(() => {
        if (!token || !userId) {
            navigate("/");
            return;
        }
        //console.log("#######################***********************WebSocket messages received: vendor status", messages);

        if (messages.length > 0) {
            //console.log('messages123 vendor tracking');

            const remainingMessages = [];

            messages.forEach((message) => {
                if (message.forPage === "crane-user-all-cases") {
                    //console.log("🚨 NEW message for data", message);
                    getData(message.accidentVehicleCode);
                    // Don't keep this message
                } else if (message.forPage === "updated-location") {
                    console.log("#######################***********************WebSocket messages received: vendor status", messages);
                    console.log('📍 Driver location update', message);
                    setDriverLocation({ lat: message.lat, lng: message.lng });
                    // Don't keep this message
                } else {
                    // Keep any unrecognized message for future processing
                    remainingMessages.push(message);
                }
            });

            // ✅ Clear used messages
            if (remainingMessages.length !== messages.length) {
                // You’ll need this from useWebSocket or Redux or Context
                if (typeof setMessages === 'function') {
                    setMessages(remainingMessages);
                } else {
                    console.warn("setMessages not available. Skipping message cleanup.");
                }
            }

            //console.log('🔚 Done processing websocket messages');
        }

        if (state?.accidentVehicleCode) {
            //console.log('📦 Fetching data via state accidentVehicleCode', state?.accidentVehicleCode);
            getData(state.accidentVehicleCode);
        }

        // Clean up localStorage if needed
        const keepKeys = [
            "iconify-version",
            "iconify-count",
            "token",
            "userId",
            "loginId",
            "loginTime",
            "userRole",
            "fromLogin",
            "justLoggedIn",
            "gps_location",
            "currentService"
        ];

        Object.keys(localStorage).forEach((key) => {
            if (!keepKeys.includes(key)) {
                localStorage.removeItem(key);
            }
        });

        sessionStorage.clear();


    }, [token, userId, navigate, messages, state]);


    const getFilteredData = (filter) => {
        //console.log("data is here");

        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        //console.log("todayDate", todayDate)
        //console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < dummyData.length; i++) {

            //console.log(dummyData[i]);
            //console.log(currentService);
            // return
            let getTime = dummyData[i]?.[`${currentService}Details`]?.systemDate?.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                //console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        //console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(dummyData[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                //console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    //console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    //console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    //console.log("Match found within last year:", dummyData[i]);
                    filteredData.push(dummyData[i]);
                }
            }
        }
        if (filter === 'newest') {
            //console.log("Sorting by newest to oldest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...dummyData]);
        } else if (filter === 'oldest') {
            //console.log("Sorting by oldest to newest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...dummyData]);
        }
        else {
            setData(filteredData)
        }
    };

    const settingFilter = (filter) => {
        //console.log('settingFilter calling: ');
        //console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }

    const getData = async (accidentVehicleCode) => {
        //console.log("userid", userId, currentService);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getParticularAccidentVehicleById/${userId}/not_defined/${accidentVehicleCode}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.data.message === "No accident vehicle data found.") {
            setData([])
            setDoneFetching(true)

        }
        else {
            const accidentData = response.data.data;
            setData(accidentData);
            setDummyData(accidentData);
            setCurrentItems(accidentData);
            setCurrentAccidentCode(accidentVehicleCode);
            setDoneFetching(true);

            if (accidentData.length > 0) {
                const item = accidentData[0]; // Assuming you only care about the first item

                Object.keys(item).forEach((key) => {
                    if (key.endsWith("Details")) {
                        const service = key.replace("Details", ""); // "crane" or "recoveryVan"
                        const serviceDetails = item[`${service}Details`];

                        // ✅ This is the safest way to work with the data right now
                        if (serviceDetails?.vendorReached && !serviceDetails?.approvedReaching) {
                            setIsExpanded(true)
                            setIsModalOpenForReached(true);
                        }

                        if (serviceDetails?.detailsFilledAt != null && !serviceDetails?.approvedRightlyMeasured) {
                            setIsExpanded(true)
                            setIsModalOpenForConfirmDetails(true);
                        }

                        if (serviceDetails?.doneWorking) {
                            setIsExpanded(true)
                            setIsModalOpenForJobDone(true);
                        }
                        if (serviceDetails?.confirmDoneWorking) {
                            setWorkDone(true);
                        }

                        if (serviceDetails?.driverLatitude && serviceDetails?.driverLongitude) {
                            setDriverLocation({
                                lat: parseFloat(serviceDetails.driverLatitude),
                                lng: parseFloat(serviceDetails.driverLongitude),
                            });
                        }

                        if (serviceDetails?.otp && !serviceDetails?.otpByCustomer) {
                            setIsExpanded(true)
                            setIsModalOpenForOTP(true);
                        }

                        // Set currentService **only after using it**
                        setCurrentService(service);
                    }
                });
            }

            //console.log("response123421", accidentData);
        }

    };



    const goToMap = (item) => {
        //console.log("itemfromgotomap", item)
        navigate('/map-vendor-distance', {
            state: {
                accidentLatitude: `${item?.[`${currentService}Details`].accidentLatitude}`,
                accidentLongitude: `${item?.[`${currentService}Details`].accidentLongitude}`,
                vendorLatitude: vendorCurrentLatitude,
                vendorLongitude: vendorCurrentLongitude,
                vehicleNo: `${item?.[`${currentService}Details`].vehicleNo}`,
                fromPage: "statusTracking"
            }
        })
    }

    const getStage = (vendorMoved, approvedReaching) => {
        return approvedReaching ? 2 : vendorMoved ? 1 : 0;
    }

    useEffect(() => {
        //console.log('data changes', data.length, currentStage.length)
        //console.log('curren4123', doneFetching)
        if (data.length > 0 && currentService && doneFetching === true) {
            //console.log("push avg")

            const newAvg = Array(data.length).fill(0);

            const newCurrentStage = data.map((item) => {
                //console.log("gostrage1")
                let gotStage = getStage(item?.[`${currentService}Details`]?.vendorMoved, item?.[`${currentService}Details`]?.approvedReaching)
                //console.log("gostrage", gotStage)
                return gotStage;
            })
            setAvg(newAvg);
            setCurrentStage(newCurrentStage);
            //console.log('currentService1231231231231', currentService)
        }

    }, [data, currentService, doneFetching])


    function haversine(lat1, lon1, lat2, lon2) {
        //console.log("accident latitude", lat1)
        //console.log("accident longtitude", lon1)
        //console.log("vehicle latitiude", lat2)
        //console.log("vehicle longtitude", lon2)

        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
    }

    const getVendorLocation = async (currentServiceId, accidentLatitude, accidentLongitude, index) => {
        try {
            //console.log("disntaceadfafdaf", distance)
            //console.log("craninging", currentServiceId, accidentLatitude, accidentLongitude, index)

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${currentServiceId}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                //console.log("accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitud", accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude)
                const calculatedDistance = haversine(accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude).toFixed(2);

                distance.push(calculatedDistance)
            }
            else if (response.data.message === "User Not found take Location") {
                //console.log("User Not found take Location")
            }
        } catch (error) {
            //console.log("error in get Vendor Location", error.message)
        }
    }

    const getVendorRating = async (crane) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${crane}/${crane}`);
            //console.log("coming Customer Rating", response.data)
            if (response.data.status === 404) {
                //console.log("Not Found")
                avg.push(0)
            }
            else if (response.data.status === true) {
                let customerRating = response.data.data;
                //console.log("coming Customer Rating", customerRating)
                if (customerRating.length !== 0) {
                    let average = customerRating.reduce((acc, item) => acc + parseInt(item.feedbackRatingCrane), 0);

                    avg.push(average / customerRating.length);
                }
            }
        } catch (error) {
            //console.log("Error from get Vendor Rating", error.message)
        }
    }

    const vendorReached = async (item, action) => {
        //console.log('items', item)
        //console.log('items', `${item[`${currentService}Details`]?.AccidentVehicleCode}`)


        //console.log('items2', `${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${userId}/${currentService}`)

        try {

            let response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${userId}/${currentService}`,
                {}, // empty body if you're not sending any data
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            //console.log('response', response)
            if (response.data.status) {
                //console.log("updated successfully")

                setSelectedAction(action)
                setAlertMessage(null)
                setAlertType(null)

                // getData()
            }

            else if (response.data.message == 'wrong OTP') {
                //console.log('wrong OTP')
                setAlertMessage("Wrong OTP. Please Check!");
                setAlertType("danger");
            }
            else 
                console.log("there is some issue")

        }
        catch (error) {
            if (error.response && error.response.data) {
                const { message } = error.response.data;

                if (message === "wrong OTP") {
                    //console.log("wrong OTP");
                    setAlertMessage("Wrong OTP. Please Check!");
                    setAlertType("danger");
                    return;
                }

                // You can handle other 400+ errors here
                //console.log("Other error:", message);
            } else {
                //console.log("Network or unknown error:", error.message);
            }
        }

    }

    useEffect(() => {
        //console.log("💥 useEffect triggered");
        //console.log("🔍 vendorDriverCode:", vendorDriverCode);
        //console.log("🔍 currentAccidentCode:", currentAccidentCode);

        if (vendorDriverCode !== null && currentAccidentCode !== null) {
            setWorkDone(true);
        }
    }, [vendorDriverCode, currentAccidentCode]);

    // ✅ Removed: RatingModal handles its own submission and navigation

    const [currentItem, setCurrentltem] = useState({})
    const [formData, setFormData] = useState({
        feedbackRating: '',
        feedback: ""
    })
    const [success, setSuccess] = useState(false)

    const workDoneConfirmation = async (item, action) => {
        try {
            setCurrentltem(item)

            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/workDoneConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${currentService}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status == true && action === true) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
                // getData()
                setIsLoading(true);
                //console.log('untisl this')
                setWorkDone(true)

                //console.log('item[`${currentService}Details`]?.AccidentVehicleCode', item[`${currentService}Details`]?.AccidentVehicleCode)
                //console.log('item[`${currentService}Details`]?.[currentService]', item[`${currentService}Details`]?.[currentService])
                setCurrentAccidentCode(item[`${currentService}Details`]?.AccidentVehicleCode)
                setVendorDriverCode(item[`${currentService}Details`]?.[currentService]);

            } else {
                setIsModalOpenForJobDone(false)
                setAlertMessage("Raised Query in Consideration...");
                setAlertType("danger"); // Bootstrap alert type for error
                setIsLoading(true);
            }

        }
        catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }
    }

    const submitNow = async (event, item) => {
        event.preventDefault();
        //console.log("asdadfasdfasdf", `${process.env.REACT_APP_BACKEND_URL}/customersRating/${currentItem.accidentFileNo}/${userId}/${currentItem.crane}`)
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/customersRating/${currentItem.accidentFileNo}/${userId}/${currentItem?.[`${currentService}`]}`, JSON.stringify(formData), {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            //console.log("response", response);
            if (response.data.status === true) {
                setAlertMessage("Updated successfully!");
                setAlertType("success");
                // setTimeout(() => {
                //     onUpdate();
                // }, 2000);
            } else {
                const errorMessage = 'An error occurred';
                setAlertMessage("An error occurred");
                setAlertType("danger");
            }
        } catch (error) {
            console.error('Error response:', error.response);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            // setAlertInfo({ show: true, message: errorMessage.toString(), severity: 'error' });
        }
    };

    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        if (vehicleNumber && dummyData.length) {
            setSearchValue(vehicleNumber)
            handleSearch(vehicleNumber)
        }
    }, [vehicleNumber, dummyData]);

    const handleSearch = (inputValue) => {
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase();
        setSearchValue(value);
        const newRows = dummyData.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly

            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row?.[`${currentService}Details`]?.vehicleNo ?? '').toLowerCase().includes(searchLower);
            const chassisNoValue = (row?.[`${currentService}Details`]?.chassisNo ?? '').toLowerCase().includes(searchLower);

            return vehicleNoValue || chassisNoValue;
        });

        setData(newRows);
    };

    //console.log("{item?.[`${currentService}Details`]?.customerAcceptedVendor", data[0]?.[`${currentService}Details`]?.customerAcceptedVendor)
    //console.log("disptan", data.length, doneFetching, distance.length, avg.length)


    const [isCancelContainerVisible, setIsCancelContainerVisible] = useState(false);
    const [reasonsForDrop, setReasonsForDrop] = useState(false);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState(null);

    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedReasons([...selectedReasons, reason]);
        }
    };

    const [errorMessage, setErrorMessage] = useState("");
    const reasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind"
    ];
    const [isLoading, setIsLoading] = useState(false);
    const [alreadyCancelled, setAlreadyCancelled] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [cancelled, setCancelled] = useState(false);
    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);

    const cancelingOrder = async (currentItem) => {
        try {
            //console.log('insoidre', currentItem)
            const reasons = [...selectedReasons, otherReason].filter(Boolean);
            if (reasons.length === 0) {
                return setAlertInfo({ show: true, message: 'Select Respective Reason', severity: 'error' });
            }
            //console.log('i am here')
            const response = await axios({
                method: "PUT",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderSecondaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}/${currentItem[`${currentService}Details`][`${currentService}`]}/${currentItem?.[`${currentService}Details`].vehicleNo}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    cancleOrderReason: [...selectedReasons, otherReason]
                }
            });

            if (response.data.status === true) {
                setIsCancelContainerVisible(false);
                setReasonsForDrop(false);
                setCancelled(true)
                // getData()
            } else {
                setAlreadyCancelled(true);
            }
        } catch (error) {
            console.error("Error canceling order:", error);
        }
    };

    const cancleCaseProcedureFunc = (item) => {
        setCurrentltem(item)
        setIsCancelContainerVisible(true)
        setReasonsForDrop(false)
        getVendorRating(item?.[`${currentService}Details`].crane)
        getVendorLocation(item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude)
    }

    const [isLoadingLoader, setIsLoadingLoader] = useState(false);




    const [buttonLoader, setButtonLoader] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userRating, setUserRating] = useState(null);
    const [userItem, setUserItem] = useState(null);

    const handleRatingSubmit = (rating) => {

        setUserRating(rating);

        //console.log("User selected rating:", rating);

        workDoneConfirmation(userItem.item, userItem.action)
    };

    const handleCancelRating = () => {
        //console.log("User canceled the rating.");
        workDoneConfirmation(userItem.item, userItem.action)
    };

    const callRatingAndWorkDoneConfirmation = (item, action) => {

        // return
        setIsModalOpen(true)
        setUserItem({ item: item, action: action, })
    }

    useEffect(() => {
        if (isExpanded) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isExpanded]);

    const handleAction = async (itemId, actionType) => {
        const key = `${itemId}_${actionType}`;
        setButtonLoader(prev => ({ ...prev, [key]: true }));

        try {
            // Simulate API call
            if (actionType === "reached") {
                await vendorReached(itemId, true);
            } else if (actionType === "notReached") {
                await vendorReached(itemId, false);
            }
            else if (actionType === "workdone") {
                await workDoneConfirmation(itemId, true);
                // navigate('/customer-home-page')
            }
            else if (actionType === "notworkdone") {
                await workDoneConfirmation(itemId, false);
            }
            // Add other actions like "accept", "reject", etc. as needed
        } catch (error) {
            console.error(error);
        } finally {
            setButtonLoader(prev => ({ ...prev, [key]: false }));
        }
    };

    const toTitleCase = (input) => {
        return input
            .split(" ")
            .map(word =>
                word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : ""
            )
            .join(" ");
    };



    //console.log('data[0]?.[`${currentService}Details`]?.driverLongitude', data[0]?.[`${currentService}Details`]?.otpByCustomer)
    const [panelHeight, setPanelHeight] = useState("60vh");

    useEffect(() => {
        const updatePanelHeight = () => {
            const viewportHeight = window.innerHeight;
            const calculatedHeight = isExpanded
                ? `${viewportHeight * 0.85}px`
                : `${viewportHeight * 0.6}px`;
            setPanelHeight(calculatedHeight);
        };

        updatePanelHeight(); // set height initially
        window.addEventListener("resize", updatePanelHeight); // update on resize

        return () => window.removeEventListener("resize", updatePanelHeight);
    }, [isExpanded]);
    const collapsedOffset = Math.min(window.innerHeight * 0.4, 300);

    return (
        <>


            <div className="fixed inset-0 overflow-hidden max-w-full font-sans text-sm bg-gradient-to-b from-white/90 to-white rounded-lg">




                {!workDone && (
                    <div>
                        {data.length > 0 && doneFetching === true && (
                            <div>
                                <div
                                    className={`relative w-full ${!isExpanded ? 'h-[100vh]' : 'h-[calc(100vh_-_30em)] md:h-[30em]'}`}
                                >
                                    <ChevronDown className='absolute rounded-md z-10 p-1 top-[1rem] w-[2rem] left-[1rem] bg-[#5cc9ff]' onClick={() => { navigate('/customer-home-page') }} />
                                    <motion.div
                                        animate={{ height: isExpanded ? "19vh" : "78vh" }}
                                        transition={{ duration: 0.1, ease: "easeInOut" }}
                                    >
                                        <OLAMapsForCustomerView
                                            dropLatitude={data[0]?.[`${currentService}Details`]?.dropLatitude}
                                            dropLongitude={data[0]?.[`${currentService}Details`]?.dropLongitude}
                                            pickupLatitude={data[0]?.[`${currentService}Details`]?.pickupLatitude}
                                            pickupLongitude={data[0]?.[`${currentService}Details`]?.pickupLongitude}
                                            driverLatitude={driverLocation?.lat}
                                            driverLongitude={driverLocation?.lng}
                                            driverOnTheWayDestination={data[0]?.[`${currentService}Details`]?.otpByCustomer !== null ? true : false}
                                            // driverOnTheWayDestination={true}
                                            fullHeightRequired={isExpanded ? false : true}
                                            fromPage="vendorStatusTracking"
                                        />
                                    </motion.div>
                                </div>

                                <div>

                                    <motion.div
                                        drag="y"
                                        dragConstraints={{ top: 0, bottom: panelHeight }}
                                        onDragEnd={handleDragEnd}
                                        dragListener={true}
                                        dragElastic={0.2}
                                        ref={sheetRef}
                                        dragPropagation
                                        initial={{ y: isExpanded ? 0 : collapsedOffset }}
                                        animate={{ y: isExpanded ? 0 : collapsedOffset }}
                                        transition={{
                                            type: "spring",
                                            stiffness: 180,
                                            damping: 35,
                                            mass: 0.5
                                        }}
                                        style={{
                                            borderTopLeftRadius: "1rem",
                                            borderTopRightRadius: "1rem",
                                            touchAction: "none", // Important for mobile
                                            height: panelHeight,
                                            minHeight: "100px",
                                            maxHeight: "90vh",
                                            overflow: 'hidden',  // Prevent content from blocking drag
                                        }}
                                        className="fixed left-0 right-0 bottom-0 z-10 bg-white shadow-xl rounded-t-xl"
                                    >

                                        <div className="w-full pt-1 h-full overflow-auto"
                                            style={{
                                                touchAction: 'none', // Prevent scroll overriding drag
                                            }}>
                                            <div onClick={toggleSheet} className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto" />

                                            {!isExpanded && data.slice(-1).map((item, dataIndex) => {
                                                return (
                                                    <div>
                                                        <div key={dataIndex} className='flex justify-between pt-2 items-center gap-[0.5rem]  px-2'>

                                                            <p className='text-[12px] font-bold'>Driver is on his way for your work</p>


                                                        </div>
                                                        <hr />



                                                        <div className="rounded-xl flex items-center justify-around bg-white w-full p-4 pt-0">
                                                            {/* Image container */}
                                                            <div className="w-10 h-10 rounded-full overflow-hidden flex justify-center bg-gray-100">
                                                                {currentService === "crane" ? (
                                                                    <img
                                                                        src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg'
                                                                        className="h-10 w-10 object-contain"
                                                                        alt="Crane" />
                                                                ) : (
                                                                    <img
                                                                        src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/craneonmap.png'
                                                                        className="h-10 w-10 object-contain"
                                                                        alt="Recovery Van" />
                                                                )}
                                                            </div>

                                                            {/* Text details */}
                                                            <div className="flex items-center space-x-4 ">
                                                                {/* Left Text */}
                                                                <div className='shadow-sm'>
                                                                    <p className="text-xs font-bold">
                                                                        {item?.[`${currentService}Details`]?.VendorDriverVehicleNo}
                                                                    </p>
                                                                    <p className="text-black text-xs font-semibold">Experienced driver</p>
                                                                </div>

                                                                {/* Vertical Divider */}
                                                                <div style={{ border: '1px solid black' }} className="h-6" />

                                                                {/* Right Text */}
                                                                <div>
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/mapimg.png' className="h-4 w-30 rounded-xl" alt="Distance Icon" />
                                                                    <span className="font-satoshi text-[11px] animate-pulse px-[2px] py-[1px] rounded-[10px] font-bold text-blue-600 bg-blue-50">
                                                                        {Boolean(!item?.[`${currentService}Details`]?.vendorMoved) && <span>Ready to move</span>}
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorMoved && !item?.[`${currentService}Details`]?.vendorReached) && <span>On the way</span>}
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && !item?.[`${currentService}Details`]?.approvedReaching) && <span>Confirm</span>}
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && item?.[`${currentService}Details`]?.approvedReaching) && <span>Reached</span>}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="flex justify-end">
                                                                <div className="gap-2 text-center">
                                                                    <button
                                                                        onClick={() => (window.location.href = 'tel:+917800784700')}
                                                                        className="p-2 shadow-md  border rounded-full border-red-500"
                                                                    >
                                                                        <PhoneCall size={24} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>




                                                )
                                            })}

                                            {isExpanded && (
                                                data.slice(-1).map((item, dataIndex) => (
                                                    <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] relative ms:px-[40px] px-[20px] pb-[1rem] rounded-[12px]  max-h-[80vh] scrollbar-hide" key={dataIndex}>
                                                        <div className="flex md:flex-row flex-col justify-between items-center pt-[19px] md:gap-0 gap-[20px]">
                                                            <div className='flex items-center w-full justify-between'>
                                                                <div className='flex gap-[0.5rem]'>
                                                                    <button className='w-fit bg-[#000000] rounded-[12px] px-[9px] py-[4px] flex items-center font-satoshi text-[12px] font-[500] text-[#FFFFFF] gap-[6px] md:hidden'>
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon18.svg' className='h-[20px] w-[20px]' alt="" />
                                                                        {parseFloat(item?.[`${currentService}Details`]?.totalDistance || 0).toFixed(2)}{" "} Km
                                                                    </button>
                                                                </div>
                                                                <div className="flex items-center ml-[4px] md:hidden">
                                                                    <WifiHigh className='animate-pulse h-[30px] w-[30px] mb-2 text-[#38bdff]' />
                                                                    <span className='font-satoshi text-[14px] animate-pulse ml-[5px] px-[4px] rounded-[10px] font-bold text-blue-600'>
                                                                        {Boolean(!item?.[`${currentService}Details`]?.vendorMoved) && <span>Ready to move</span>}
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorMoved && !item?.[`${currentService}Details`]?.vendorReached) && <span>On the way</span>}
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && !item?.[`${currentService}Details`]?.approvedReaching) && <span>Confirm</span>}
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && item?.[`${currentService}Details`]?.approvedReaching) && <span>Reached At Spot</span>}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className='hidden md:block flex w-full justify-end items-center md:gap-[80px] gap-[20px]'>
                                                                <div className="flex flex-row gap-2 items-center">
                                                                    <button className='w-fit bg-[#000000] rounded-[12px] px-[9px] py-[4px] flex items-center font-satoshi text-[12px] font-[500] text-[#FFFFFF] gap-[6px]'>
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon18.svg' className='h-[20px] w-[20px]' alt="" />
                                                                        {parseFloat(item?.[`${currentService}Details`]?.totalDistance || 0).toFixed(2)}{" "} Km
                                                                    </button>

                                                                    <div className="flex items-center ml-[4px]">
                                                                        <WifiHigh className='animate-pulse h-[30px] w-[30px] text-[#38bdff]' />
                                                                        <span className='font-satoshi text-[14px] animate-pulse ml-[5px] px-[4px] rounded-[10px] font-bold text-green-600'>
                                                                            {Boolean(!item?.[`${currentService}Details`]?.vendorMoved) && <span>Ready to move</span>}
                                                                            {Boolean(item?.[`${currentService}Details`]?.vendorMoved && !item?.[`${currentService}Details`]?.vendorReached) && <span>On the way</span>}
                                                                            {Boolean(item?.[`${currentService}Details`]?.vendorReached && !item?.[`${currentService}Details`]?.approvedReaching) && <span>Confirm</span>}
                                                                            {Boolean(item?.[`${currentService}Details`]?.vendorReached && item?.[`${currentService}Details`]?.approvedReaching) && <span>Reached At Spot</span>}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div className="flex items-center justify-between max-w-[536px] mx-auto w-full md:pt-[30px] pt-[1rem]">
                                                            {stages.map((stage, index) => {
                                                                const isCurrent = currentStage[dataIndex] === index;
                                                                const isPast = currentStage[dataIndex] > index;
                                                                const isNext = currentStage[dataIndex] + 1 === index;

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            textAlign: "center",
                                                                            position: "relative",
                                                                            flex: 1,
                                                                        }}
                                                                    >
                                                                        {/* Circle with animated ring for current */}
                                                                        <div
                                                                            style={{
                                                                                width: "2rem",
                                                                                height: "2rem",
                                                                                borderRadius: "50%",
                                                                                backgroundColor: isCurrent
                                                                                    ? index === 2
                                                                                        ? "rgb(11 219 255)"
                                                                                        : "#21A6E9"
                                                                                    : "#ffffff",
                                                                                boxShadow: isCurrent ? "0 0 0 4px rgba(33, 166, 233, 0.5)" : "none",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                border: isCurrent ? "2px solid #4CAF50" : "1px solid black",
                                                                                transition: "background-color 0.3s ease",
                                                                                zIndex: 1,
                                                                                marginTop: "5px",
                                                                                animation: isCurrent ? "pulse 1.5s infinite" : "none",
                                                                            }}
                                                                        >
                                                                            {/* <img
                                                                                src={stage.img}
                                                                                alt={stage.label}
                                                                                style={{
                                                                                    width: "2rem",
                                                                                    height: "1.1rem",
                                                                                    opacity: isPast || isCurrent ? 1 : 0.5,
                                                                                }}
                                                                            /> */}
                                                                            <stage.icon
                                                                                size={18}
                                                                                color={isPast || isCurrent ? "#000" : "#999"}
                                                                                style={{ opacity: isPast || isCurrent ? 1 : 0.5 }}
                                                                            />
                                                                        </div>

                                                                        <p
                                                                            style={{
                                                                                marginTop: "5px",
                                                                                color: isPast || isCurrent ? "black" : "#aaa",
                                                                                fontWeight: isCurrent ? "bold" : "normal",
                                                                                fontSize: "11px",
                                                                            }}
                                                                        >
                                                                            {stage.label}
                                                                        </p>

                                                                        {index < stages.length - 1 && (
                                                                            <div
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "20px", // Adjust to align vertically with stage icons
                                                                                    left: "60%",
                                                                                    width: "85%",
                                                                                    height: "3px", // Increased height
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    zIndex: 0,
                                                                                }}
                                                                            >
                                                                                {/* Left half */}
                                                                                <div
                                                                                    style={{
                                                                                        height: "3px",
                                                                                        backgroundColor:
                                                                                            currentStage[dataIndex] === index ? "#4CAF50" : "#B1B1B1",
                                                                                        flex: 1,
                                                                                        marginRight: "2px",
                                                                                        borderRadius: "2px",
                                                                                        transition: "background-color 0.3s ease",
                                                                                    }}
                                                                                />

                                                                                {/* Only show dot if this is the line between current and next */}
                                                                                {currentStage[dataIndex] === index && (
                                                                                    <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse z-10" />
                                                                                )}

                                                                                {/* Right half */}
                                                                                <div
                                                                                    style={{
                                                                                        height: "3px",
                                                                                        backgroundColor: "#B1B1B1",
                                                                                        flex: 1,
                                                                                        marginLeft: "-2px",
                                                                                        borderRadius: "2px",
                                                                                        transition: "background-color 0.3s ease",
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}


                                                                    </div>
                                                                );
                                                            })}
                                                        </div>

                                                        {/* <div className="h-full w-full rounded-xl overflow-hidden mt-3" onClick={() => { goToMap(item) }}> */}
                                                        {/* <MapForVendorDistance state={{ fromPage: 'statusTracking' }} /> */}
                                                        {/* </div> */}
                                                        <div className='pt-[1rem]'>
                                                            <div className="flex md:flex-row flex-col gap-[24px] items-start">
                                                                <div className="flex sm:flex-col flex-row items-center justify-around w-full md:hidden">

                                                                    {currentService == "crane" ? (
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg' style={{ borderRadius: '50%' }} className="h-[5rem] w-[3rem] object-contain shadow-md" alt="" />
                                                                    ) : (
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumRecoveryVan.jpg' style={{ borderRadius: '50%' }} className="h-[5rem] w-[4.5rem] object-contain shadow-md" alt="" />
                                                                    )}
                                                                    <div className='flex flex-col'>

                                                                        <div>
                                                                            <h6 className="m-0 font-[700] font-satoshi text-[15px] sm:text-[15px] text-[#0A0119] pb-[2px]">
                                                                                {item?.[`${currentService}Details`].VendorDriverVehicleNo}
                                                                            </h6>
                                                                                                             {/* Driver's name and contact number */}

                                      <div className="mt-1">
                                        <p className="font-[500] m-0 font-satoshi text-[12px] sm:text-[13px] text-[#515151]">
                                          {item?.[`${currentService}Details`]
                                            ?.vendorDriverName ||
                                            "Driver Name Not Available"}
                                        </p>
                                        <p className="font-[500] m-0 font-satoshi text-[12px] sm:text-[13px] text-[#515151] text-blue-500">
                                          {item?.[`${currentService}Details`]
                                            ?.vendorDriverNumber ? ( 
                                            <a
                                            href={`tel:${item[`${currentService}Details`].vendorDriverNumber}`}
                                            className="text-blue-600 underline"
                                            >
                                            {item[`${currentService}Details`].vendorDriverNumber}
                                            </a>) : (
                                            "Contact Not Available"
                                            )}
                                        </p>
                                      </div>

                                                                            {/* <p className="font-[500] flex m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]"><p>Vehicle No</p> <span></span></p> */}
                                                                        </div>
                                                                        <p className="text-green-600 text-[11px]">Experienced driver</p>

                                                                        <div className='sm:hidden'>
                                                                            <p className="font-[500] m-0 font-satoshi font-semibold text-[11px] sm:text-[11px] text-[#515151]">
                                                                                Connected On{" "} {
                                                                                    (() => {
                                                                                        const utcString = item?.[`${currentService}Details`]?.connectedVendorFullyTime;
                                                                                        if (!utcString) return 'N/A';

                                                                                        const utcDate = new Date(utcString);
                                                                                        const istDate = new Date(utcDate.getTime() + (5.5 * 60 * 60 * 1000)); // Add 5:30

                                                                                         const day = String(
                                                                                    istDate.getUTCDate()
                                                                                ).padStart(2, "0");
                                                                                const month = String(
                                                                                    istDate.getUTCMonth() + 1
                                                                                ).padStart(2, "0");
                                                                                const year = istDate.getUTCFullYear();
                                                                                let hours = istDate.getUTCHours();
                                                                                const minutes = String(
                                                                                    istDate.getUTCMinutes()
                                                                                ).padStart(2, "0");
                                                                                const seconds = String(
                                                                                    istDate.getUTCSeconds()
                                                                                ).padStart(2, "0");
                                                                                const ampm =
                                                                                    hours >= 12 ? "PM" : "AM";
                                                                                hours = hours % 12;
                                                                                hours = hours ? hours : 12;
                                                                                return `${day}/${month}/${year} (${hours}:${minutes}:${seconds} ${ampm})`;
                                                                                    })()
                                                                                }
                                                                            </p>

                                                                        </div>
                                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && !item?.[`${currentService}Details`]?.approvedReaching) && (
                                                                            <div>

                                                                                <div className="flex justify-end">
                                                                                    <button
                                                                                        className="bg-[#21A6E9] py-2 px-3 mt-[0.5rem] rounded-full text-white font-satoshi font-medium text-[12px] disabled:opacity-50"
                                                                                        onClick={() => setIsModalOpenForReached(true)}
                                                                                    >
                                                                                        Please Confirm Reached
                                                                                    </button>
                                                                                </div>


                                                                                <AnimatePresence>
                                                                                    {isModalOpenForReached && (
                                                                                        <div
                                                                                            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                                                                                        // initial={{ opacity: 0 }}
                                                                                        // animate={{ opacity: 1 }}
                                                                                        // exit={{ opacity: 0 }}
                                                                                        >
                                                                                            <div
                                                                                                className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative"
                                                                                            // initial={{ scale: 0.8, opacity: 0 }}
                                                                                            // animate={{ scale: 1, opacity: 1 }}
                                                                                            // exit={{ scale: 0.8, opacity: 0 }}
                                                                                            // transition={{ duration: 0.3 }}
                                                                                            >
                                                                                                {/* Cross Button */}
                                                                                                <button
                                                                                                    onClick={() => setIsModalOpenForReached(false)}
                                                                                                    className="absolute top-2 right-2 text-gray-500 hover:text-red-600 transition-all"
                                                                                                >
                                                                                                    <X className="w-5 h-5" />
                                                                                                </button>

                                                                                                <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                                                                    Please confirm vehicle{" "}
                                                                                                    {item?.[`${currentService}Details`]?.VendorDriverVehicleNo}{" "} has
                                                                                                    reached.
                                                                                                </p>


                                                                                                {alertMessage && (
                                                                                                    <div
                                                                                                        style={{ marginTop: "20px", fontSize: "12px", padding: "10px" }}
                                                                                                        className={`alert alert-${alertType} text-center`}
                                                                                                        role="alert"
                                                                                                    >
                                                                                                        {alertMessage}
                                                                                                    </div>
                                                                                                )}

                                                                                                {/* Action Buttons */}
                                                                                                <div className="flex gap-4">
                                                                                                    <button
                                                                                                        className="bg-[#21A6E9] flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                                                                        onClick={() => handleAction(item, "reached")}
                                                                                                    >
                                                                                                        {buttonLoader[`${item}_reached`] && (
                                                                                                            <span className="spinner-border spinner-border-sm me-1"></span>
                                                                                                        )}
                                                                                                        Reached
                                                                                                    </button>

                                                                                                    <button
                                                                                                        className="bg-[#EE3840]  flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                                                                        onClick={() => handleAction(item, "notReached")}
                                                                                                        disabled={buttonLoader[`${item}_notReached`]}
                                                                                                    >
                                                                                                        {buttonLoader[`${item}_notReached`] && (
                                                                                                            <span className="spinner-border spinner-border-sm me-1"></span>
                                                                                                        )}
                                                                                                        Not Reached
                                                                                                    </button>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </AnimatePresence>
                                                                            </div>
                                                                        )}

                                                                        {Boolean(item?.[`${currentService}Details`]?.detailsFilledAt != null && !item?.[`${currentService}Details`]?.approvedRightlyMeasured) && (
                                                                            <>
                                                                                {/* Trigger Button */}
                                                                                <div className="flex justify-end">
                                                                                    <button
                                                                                        className="bg-[#21A6E9] py-2 px-3 mt-[0.5rem] rounded-full text-white font-satoshi font-medium text-[12px] disabled:opacity-50"
                                                                                        onClick={() => setIsModalOpenForConfirmDetails(true)}
                                                                                    >
                                                                                        Please Confirm Details
                                                                                    </button>
                                                                                </div>

                                                                                {/* Animated Modal */}
                                                                                {isModalOpenForConfirmDetails && (
                                                                                    <div
                                                                                        className="fixed inset-0 z-50 flex items-center justify-center bg-black h-full bg-opacity-50"
                                                                                    >
                                                                                        <div
                                                                                            className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative"
                                                                                        >
                                                                                            {/* Close Button */}
                                                                                            <button
                                                                                                onClick={() => setIsModalOpenForConfirmDetails(false)}
                                                                                                className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                                                                            >
                                                                                                <X className="w-5 h-5" />
                                                                                            </button>

                                                                                            {/* Modal Content */}
                                                                                            <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                                                                Please confirm the details provided by service provider.
                                                                                            </p>


                                                                                            {/* {item?.[`${currentService}Details`]?.vendorType} */}
                                                                                            <ShowVehicleInspectionFlow accidentVehicleCode={item?.[`${currentService}Details`]?.AccidentVehicleCode}
                                                                                                vendorType={item?.[`${currentService}Details`]?.vendorType}
                                                                                            > </ShowVehicleInspectionFlow>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}

                                                                        {Boolean(item?.[`${currentService}Details`]?.otp && !item?.[`${currentService}Details`]?.otpByCustomer) && (
                                                                            <div>

                                                                                <div className="flex justify-end">
                                                                                    <button
                                                                                        className="bg-[#21A6E9] py-2 px-3 mt-[0.5rem] rounded-full text-white font-satoshi font-medium text-[12px] disabled:opacity-50"
                                                                                        onClick={() => setIsModalOpenForOTP(true)}
                                                                                    >
                                                                                        Please Share OTP
                                                                                    </button>
                                                                                </div>


                                                                                <AnimatePresence>
                                                                                    {isModalOpenForOTP && (
                                                                                        <div
                                                                                            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                                                                                            initial={{ opacity: 0 }}
                                                                                            animate={{ opacity: 1 }}
                                                                                            exit={{ opacity: 0 }}
                                                                                        >
                                                                                            <div
                                                                                                className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative"
                                                                                                initial={{ scale: 0.8, opacity: 0 }}
                                                                                                animate={{ scale: 1, opacity: 1 }}
                                                                                                exit={{ scale: 0.8, opacity: 0 }}
                                                                                                transition={{ duration: 0.3 }}
                                                                                            >
                                                                                                {/* Cross Button */}
                                                                                                <button
                                                                                                    onClick={() => setIsModalOpenForOTP(false)}
                                                                                                    className="absolute top-2 right-2 text-gray-500 hover:text-red-600 transition-all"
                                                                                                >
                                                                                                    <X className="w-5 h-5" />
                                                                                                </button>

                                                                                                <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                                                                    Please share OTP to service vehicle's driver.
                                                                                                </p>

                                                                                                <div className="flex justify-center items-center gap-2 mt-1 px-6 ">
                                                                                                    <p className='text-sm font-bold text-blue-500 font-satoshi'>OTP :</p>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        inputMode="numeric"
                                                                                                        // value={item?.[`${currentService}Details`]?.otp}
                                                                                                        maxLength={4}
                                                                                                        className="absolute opacity-0 pointer-events-none"
                                                                                                        autoFocus
                                                                                                        readOnly
                                                                                                    />
                                                                                                    {[...Array(4)].map((_, i) => (
                                                                                                        <div
                                                                                                            key={i}
                                                                                                            style={{ border: '1px solid green' }}
                                                                                                            className="font-satoshi w-5 h-5 border-1 text-green-900 mt-1 mb-2 rounded-md flex items-center justify-center text-xs font-semibold"
                                                                                                        >
                                                                                                            {item?.[`${currentService}Details`]?.otp[i] || ""}
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                                {/* OTP Input */}
                                                                                                {/* <div
                                                                                        className="flex justify-center items-center gap-2 mt-1 mb-3 cursor-text"
                                                                                        onClick={handleClick}
                                                                                    >
                                                                                        <p className="text-xs font-satoshi">Give OTP:</p>
                                                                                        <input
                                                                                            ref={inputRef}
                                                                                            type="text"
                                                                                            value={otp}
                                                                                            onChange={handleChange}
                                                                                            maxLength={6}
                                                                                            className="absolute opacity-0 pointer-events-none"
                                                                                            autoFocus
                                                                                        />
                                                                                        {[...Array(6)].map((_, i) => (
                                                                                            <div
                                                                                                key={i}
                                                                                                style={{ border: "1px solid black" }}
                                                                                                className="font-satoshi w-5 h-5 border-1 mt-1 mb-2 border-gray-300 rounded-md flex items-center justify-center text-xs font-semibold"
                                                                                            >
                                                                                                {otp[i] || ""}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div> */}

                                                                                                {alertMessage && (
                                                                                                    <div
                                                                                                        style={{ marginTop: "20px", fontSize: "12px", padding: "10px" }}
                                                                                                        className={`alert alert-${alertType} text-center`}
                                                                                                        role="alert"
                                                                                                    >
                                                                                                        {alertMessage}
                                                                                                    </div>
                                                                                                )}

                                                                                                {/* Action Buttons */}
                                                                                                {/* <div className="flex gap-4">
                                                                                        <button
                                                                                            className="bg-green-700 flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                                                            onClick={() => handleAction(item, "reached")}

                                                                                        >
                                                                                            {buttonLoader[`${item}_reached`] && (
                                                                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                                                                            )}
                                                                                            Reached
                                                                                        </button>

                                                                                        <button
                                                                                            className="bg-red-700 flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] disabled:opacity-50"
                                                                                            onClick={() => handleAction(item, "notReached")}
                                                                                            disabled={buttonLoader[`${item}_notReached`]}
                                                                                        >
                                                                                            {buttonLoader[`${item}_notReached`] && (
                                                                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                                                                            )}
                                                                                            Not Reached
                                                                                        </button>
                                                                                    </div> */}

                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </AnimatePresence>
                                                                            </div>
                                                                        )}

                                                                        {Boolean(item?.[`${currentService}Details`]?.doneWorking) && (
                                                                            <>
                                                                                {/* Trigger Button */}
                                                                                <div className="flex justify-end">
                                                                                    <button
                                                                                        className="bg-[#21A6E9] py-2 px-3 mt-[0.5rem] rounded-full text-white font-satoshi font-medium text-[12px]"
                                                                                        onClick={() => setIsModalOpenForJobDone(true)}
                                                                                    >
                                                                                        Confirm Job Status
                                                                                    </button>
                                                                                </div>

                                                                                {/* Animated Modal */}

                                                                                <AnimatePresence>
                                                                                    {isModalOpenForJobDone && (
                                                                                        <div
                                                                                            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                                                                                            initial={{ opacity: 0 }}
                                                                                            animate={{ opacity: 1 }}
                                                                                            exit={{ opacity: 0 }}
                                                                                        >
                                                                                            <div
                                                                                                className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative"
                                                                                                initial={{ scale: 0.8, opacity: 0 }}
                                                                                                animate={{ scale: 1, opacity: 1 }}
                                                                                                exit={{ scale: 0.8, opacity: 0 }}
                                                                                                transition={{ duration: 0.3 }}
                                                                                            >
                                                                                                {/* Close Button */}
                                                                                                <button
                                                                                                    onClick={() => setIsModalOpenForJobDone(false)}
                                                                                                    className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                                                                                >
                                                                                                    <X className="w-5 h-5" />
                                                                                                </button>


                                                                                                {/* Modal Content */}
                                                                                                <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                                                                    Please confirm the details provided by service provider.
                                                                                                </p>
                                                                                                {/* <ModalButton
                                                                                        className="bg-[#21A6E9] flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px] w-full"
                                                                                        state={{
                                                                                            accidentVehicleCode: item?.[`${currentService}Details`]?.AccidentVehicleCode,
                                                                                            title: 'Reconfirm details',
                                                                                            currentService: currentService,
                                                                                        }}
                                                                                    /> */}
                                                                                                <ShowVehicleInspectionFlow accidentVehicleCode={item?.[`${currentService}Details`]?.AccidentVehicleCode}
                                                                                                    vendorType={item?.[`${currentService}Details`]?.vendorType}
                                                                                                    currentService={currentService}
                                                                                                >  {" "} </ShowVehicleInspectionFlow>
                                                                                                <div className="flex gap-3 mt-[1rem]">
                                                                                                    <button
                                                                                                        className="bg-[#21A6E9] py-[10px] px-[12px] w-full rounded-full text-white font-satoshi font-medium text-[13px] flex justify-center items-center gap-2"
                                                                                                        onClick={() => handleAction(item, "workdone")}
                                                                                                        disabled={buttonLoader[`${item}_workdone`]}
                                                                                                    >
                                                                                                        {buttonLoader[`${item}_workdone`] && <ClipLoader color="white" size={16} />}
                                                                                                        Completed
                                                                                                    </button>

                                                                                                    <button
                                                                                                        className="bg-red-700 py-[10px] px-[9px] w-full rounded-full text-white font-satoshi font-medium text-[12px] flex justify-center items-center gap-2"
                                                                                                        onClick={() => handleAction(item, "notworkdone")}
                                                                                                        disabled={buttonLoader[`${item}_notworkdone`]}
                                                                                                    >
                                                                                                        {buttonLoader[`${item}_notworkdone`] && <ClipLoader color="white" size={12} />}
                                                                                                        Not Completed
                                                                                                    </button>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </AnimatePresence>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>




                                                                {/* Delivery Partner Info */}
                                                                <div className="bg-white rounded-xl shadow-md w-full p-4 border border-green-500">
                                                                    <div className="flex justify-between items-center w-full">

                                                                        {/* Vehicle Image */}
                                                                        <div className="w-[4.5rem] h-[4.5rem] rounded-full overflow-hidden shadow-lg flex-shrink-0">
                                                                            {/* <img
                                                                                src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg'
                                                                                alt="Vehicle"
                                                                                className="w-full h-full object-contain"
                                                                                style={{ borderRadius: '50%' }}
                                                                            /> */}

                                                                            {/* Instead of default claimpro truck it shows first vehicle image uploaded by the customer */}
                                      <img
                                        src={
                                          item?.[`${currentService}Details`]?.images?.
                                            ["Front Right"]
                                            ? item[`${currentService}Details`]?.images?.
                                                ["Front Right"]
                                            : "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg"
                                        }
                                        alt="Vehicle"
                                        className="w-full h-full object-cover"
                                        style={{ borderRadius: "50%" }}
                                        onError={(e) => {
                                          e.target.src =
                                            "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/front-left.jpg";
                                        }}
                                      />
                                                                        </div>

                                                                        {/* Details */}
                                                                        <div className="flex flex-col justify-center gap-y-1 w-full pl-4">
                                                                            <p className=" text-xs font-semibold text-gray-700">
                                                                                Vehicle No:{" "}<span className="text-black font-bold  text-xs">{item?.[`${currentService}Details`]?.vehicleNo}</span>
                                                                            </p>
                                                                            <p className=" text-xs font-bold text-gray-600">
                                                                                Representative Name & Contact: <span className="text-black text-xs font-semibold">{item?.[`${currentService}Details`]?.driverName || 'N/A'},{" "} {item?.[`${currentService}Details`]?.driverNumber}</span>
                                                                            </p>

                                                                        </div>

                                                                    </div>
                                                                </div>



                                                                {/* Delivery Details */}
                                                                <div className="bg-white rounded-xl  w-[90vw] shadow p-4 space-y-3">
                                                                    <p className="text-xs text-orange-500 font-semibold">All your details in one place 👇</p>

                                                                    <div className="flex items-center justify-between">
                                                                        <div className="flex items-center space-x-2 text-sm text-gray-700">
                                                                            <MapPin size={16} />
                                                                            <span>
                                                                                <div className="flex flex-col max-w-full">
                                                                                    <h6
                                                                                        className={`m-0 font-[700] font-satoshi text-[11px] sm:text-[24px] text-[#0A0119] pb-[6px] ${showFull
                                                                                            ? 'whitespace-normal break-words'
                                                                                            : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px]'
                                                                                            }`}
                                                                                        onClick={() => setShowFull(!showFull)}
                                                                                    >
                                                                                        {toTitleCase(item?.[`${currentService}Details`]?.pickupLocation)}
                                                                                    </h6>
                                                                                    <p className="font-[500] m-0 font-satoshi text-[11px] sm:text-[11px] text-[#515151]">
                                                                                        Pickup Location
                                                                                    </p>
                                                                                </div>

                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex items-center justify-between">
                                                                        <div className="flex items-center space-x-2 text-sm text-gray-700">
                                                                            <MapPin size={16} />
                                                                            <span>
                                                                                <h6
                                                                                    className={`m-0 font-[700] font-satoshi text-[11px] sm:text-[11px] mt-[1rem]  text-[#0A0119] pb-[6px] md:mt-0  ${showFull2
                                                                                        ? 'whitespace-normal  break-words'
                                                                                        : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px]'
                                                                                        }`}
                                                                                    onClick={() => setShowFull2(!showFull2)}
                                                                                >
                                                                                    {toTitleCase(item?.[`${currentService}Details`]?.dropLocation)}
                                                                                </h6>
                                                                                <p className="font-[500] mt-0 font-satoshi text-[11px] sm:text-[11px] text-[#515151]">
                                                                                    Drop Location
                                                                                </p></span>
                                                                        </div>
                                                                        <div className="flex justify-end">
                                                                            <div className="gap-2 text-center">
                                                                                <button
                                                                                    onClick={() => (window.location.href = 'tel:+917800784700')}
                                                                                    className="p-2 shadow-md  border rounded-full border-red-500"
                                                                                >
                                                                                    <PhoneCall size={24} />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                            </div>





                                                            {alertMessage && (
                                                                <div style={{ marginTop: "20px", fontSize: "12px", padding: "10px" }} className={`alert alert-${alertType} text-center`} role="alert">
                                                                    {alertMessage}
                                                                </div>
                                                            )}


                                                            {isCancelContainerVisible && (
                                                                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
                                                                    <div className="bg-white py-[1rem] px-[1rem] pt-[3rem] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                                                                        <img onClick={(e) => {
                                                                            setIsCancelContainerVisible(false)
                                                                            setReasonsForDrop(false)
                                                                            setSelectedReasons([])
                                                                            setOtherReason('')
                                                                        }}
                                                                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='absolute top-[12px] right-[12px] h-[2rem] w-[2rem]' alt="" />
                                                                        <div>
                                                                            {reasonsForDrop == false && (
                                                                                <div>
                                                                                    <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] my-4 text-[#0A0119] pb-[6px]">We are almost there to get you perfect service !!! </p>
                                                                                    <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  my-4 pb-[6px] text-[#EE3840]">Still want to opt-out for ❓ </p>
                                                                                    <div className=" grid md:grid-cols-2 grid-cols-2  items-center gap-[0.5rem]">
                                                                                        <div onClick={() => setReasonsForDrop(true)} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[1rem] w-full cursor-pointer justify-between items-center">
                                                                                            <button className="font-satoshi font-[400] text-[14px] leading-[33.6px] text-[#FFFFFF]">Cancel</button>
                                                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[1rem] w-[1rem]' alt="" />
                                                                                        </div>
                                                                                        <div
                                                                                            onClick={(e) => {
                                                                                                setReasonsForDrop(false)
                                                                                                setIsCancelContainerVisible(false)
                                                                                                setSelectedReasons([])
                                                                                                setOtherReason('')
                                                                                            }}
                                                                                            className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[1rem] w-full justify-between items-center cursor-pointer">
                                                                                            <button className="font-satoshi font-[400] text-[13px] leading-[33.6px] pr-[1rem] text-[#FFFFFF]">Don't Cancel</button>
                                                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[1rem] w-[1rem]' alt="" />
                                                                                        </div>

                                                                                    </div>
                                                                                </div>)}

                                                                            {reasonsForDrop == true && (
                                                                                <div>
                                                                                    <div>
                                                                                        <div>

                                                                                            <div style={{ margin: "10px", marginTop: '20px', display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                                                {reasons.map((reason) => (
                                                                                                    <button
                                                                                                        key={reason}
                                                                                                        onClick={() => handleSelectReason(reason)}
                                                                                                        style={{
                                                                                                            fontSize: '16px',
                                                                                                            display: "flex",
                                                                                                            justifyContent: "center",
                                                                                                            alignItems: "center",
                                                                                                            padding: "15px",
                                                                                                            borderRadius: "20px",
                                                                                                            backgroundColor: selectedReasons.includes(reason) ? "#21A6E9" : "white",
                                                                                                            color: selectedReasons.includes(reason) ? "white" : "black",

                                                                                                            border: "1px solid #21A6E9",
                                                                                                            cursor: "pointer",
                                                                                                            boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                                                                                        }}
                                                                                                    >
                                                                                                        {reason}
                                                                                                    </button>
                                                                                                ))}
                                                                                            </div>


                                                                                            <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                                                                                <p style={{ textAlign: "left", fontSize: '16px' }}> {" "}Other Reason  : </p>
                                                                                                <p style={{ textAlign: "left", fontSize: '16px' }}> {" "}Other Reason  : </p>
                                                                                                <p style={{ textAlign: "left", fontSize: '16px' }}> {" "}Other Reason  : </p>
                                                                                                <textarea
                                                                                                    style={{ margin: "10px 10px 5px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                                                                            </label>

                                                                                            {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                                                                            <div className='pb-10'>
                                                                                                {isLoading && (
                                                                                                    <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                                                        <ClipLoader color="black" loading={isLoading} />
                                                                                                        <div style={{ marginTop: '10px', color: 'black' }}> {" "} Please Wait...</div>
                                                                                                    </div>
                                                                                                )}
                                                                                                {alreadyCancelled && (<div class="alert alert-danger" role="alert">
                                                                                                    You have already Cancelled Case !!!
                                                                                                </div>)}
                                                                                                {alertInfo.show && (
                                                                                                    <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                                                                        {alertInfo.message}
                                                                                                    </Alert>
                                                                                                )}

                                                                                                <div onClick={(e) => { cancelingOrder(currentItem) }} disabled={isLoading} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Confirm Drop Case</button>
                                                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            )}


                                                        </div>
                                                    </div>))
                                            )}
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        )}
                        {data.length === 0 && doneFetching && (
                            <div>
                                <NoDataFound />
                            </div>
                        )}
                    </div>)}

                {workDone && (
                    <RatingModal
                        state={{
                        vendorDriverCode: vendorDriverCode,
                        accidentVehicleCode: currentAccidentCode,
                        currentService: currentService,
                        }}
                        onClose={() => {
                          setWorkDone(false);
                          localStorage.removeItem("currentAccidentCode");
                          localStorage.removeItem("currentService");
                        }}
                    />
                    )}

                {/* <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                    <div className="mobile-only-shadow flex items-center justify-between bg-white  p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                        <button

                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"

                        >
                            Back
                            <img src={rightArrow} alt="Continue" className="h-[24px] w-[24px]" />
                        </button>
                      

                        <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                    </div>
                </div> */}


                {/* Modal */}
                {/* <ModalForWaiting
                isOpen={isModalWaitingProp}
                onClose={() => setIsModalWaiting(false)}
            /> */}
            </div >


        </>
    )
}

export default VendorStatusTracking;